export default __webpack_public_path__ + "static/media/19.c2e0b00f.jpg";